<markdown class="prose" [data]="markdownContent"></markdown>
